import React, { useCallback, useEffect, useRef } from "react";

import { Collapsible, Loading } from "../../components";
import { steps } from "../constants";
import { useUpsertLookbook } from "../useUpsertLookbook";
import { getApiUrl } from '../../core/config/api';
import { usePoll } from "../../hooks/usePoll";

export function Preview() {
  const {
    currentStep,
    getCollapsibleState,
    toggleCollapsible,
    createOrUpdateLookbook,
    previewFileId,
    savePdf,
    updateLising,
  } = useUpsertLookbook();
  const { isOpen, isVisible } = getCollapsibleState(steps.PREVIEW);

  useEffect(() => {
    if (!isOpen) {
      return;
    }
    createOrUpdateLookbook();
  }, [isOpen]);

  // Wait for the PDF: every 5 s until it has a file_id. usePoll backs off on
  // errors, stops on 403/404 and pauses in a hidden tab (M4.1) — this used to
  // be a setInterval that re-asked a failing server every 5 s forever.
  const updateRef = useRef(updateLising);
  updateRef.current = updateLising;
  const poll = useCallback(() => updateRef.current(), []);
  const { failing, stopped } = usePoll(poll, {
    interval: 5000,
    enabled: currentStep === steps.PREVIEW && !previewFileId,
  });

  let waitingText = "Please wait while the PDF is prepared...";
  if (stopped) waitingText = "The preview could not be loaded. Reload the page to try again.";
  else if (failing) waitingText = "Reconnecting…";

  if (!isVisible) {
    return null;
  }

  return (
    <Collapsible
      trigger="Preview"
      handleTriggerClick={() => toggleCollapsible(steps.PREVIEW)}
      open={isOpen}
      testId="lookbook-preview"
      noContainer
      className="lookbook-preview-section"
    >
      <div className="lookbook-preview">
        <div className="bbb">
          {!previewFileId && (
            <Loading
              text={waitingText}
              type="loading"
            />
          )}
          {previewFileId && previewFileId && (
            <div id="pdfContainer">
             <object
                data={getApiUrl(`/api/pdfs/${previewFileId}`)}
                type="application/pdf"
                width="100%"
                height="100%"
              />
            </div>
          )}
        </div>

        <div className="preview-actions">
          {previewFileId && (
            <button type="button" onClick={savePdf}>
              Save PDF
            </button>
          )}
        </div>
      </div>
    </Collapsible>
  );
}
